import type { useCategoryHeaderModel } from '@/components/catalog/category-header/category-header.model'

type CategoryHeaderViewProps = ReturnType<typeof useCategoryHeaderModel>

export function CategoryHeaderView({
  title,
  story,
  countLabel,
}: CategoryHeaderViewProps) {
  return (
    <header className="fz-category-header">
      <span className="fz-category-header__eyebrow">Catálogo</span>
      <h1 className="fz-category-header__title">{title}</h1>
      <p className="fz-category-header__story">{story}</p>
      <span className="fz-category-header__count">{countLabel}</span>
    </header>
  )
}
